<template>
  <b-sidebar
    id="add-new-user-sidebar"
    :visible="isAddNewUserSidebarActive"
    bg-variant="white"
    sidebar-class="sidebar-lg"
    shadow
    backdrop
    no-header
    right
    @hidden="resetForm"
    @change="(val) => toggleSidebar(val)"
  >
    <template #default="{ hide }">
      <!-- Header -->
      <div class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1">
        <h5 class="mb-0">
          {{ titleForm }}
        </h5>

        <feather-icon
          class="ml-1 cursor-pointer"
          icon="XIcon"
          size="16"
          @click="hide"
        />

      </div>

      <!-- BODY -->
      <validation-observer
        #default="{ handleSubmit }"
        ref="refFormObserver"
      >
        <!-- Form -->
        <b-form
          class="p-2"
          @submit.prevent="handleSubmit(onSubmit)"
          @reset.prevent="resetForm"
        >
          <validation-provider
            #default="validationContext"
            name="Código"
            rules="required"
          >
            <b-form-group
              label="Código"
              label-for="codigo"
            >
              <b-form-input
                id="codigo"
                v-model="formData.codigo"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Nombre"
            rules="required"
          >
            <b-form-group
              label="Nombre"
              label-for="nombre"
            >
              <b-form-input
                id="nombre"
                v-model="formData.nombre"
                :state="getValidationState(validationContext)"
                trim
                placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Departamento"
            rules="required"
          >
            <b-form-group
              label="Departamento"
              label-for="departamento"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="formData.departamento"
                placeholder=".: Seleccione Departamento :."
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionDepartamento"
                :reduce="m => m.codigoDepartamento"
                label="descripcion"
                :clearable="false"
                input-id="descripcion"
                @input="getSelectedDepartamento"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Provincia"
            rules="required"
          >
            <b-form-group
              label="Provincia"
              label-for="provincia"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="formData.provincia"
                placeholder=".: Seleccione Provincia :."
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionProvincia"
                :reduce="m => m.codigoProvincia"
                label="descripcion"
                :clearable="false"
                input-id="descripcion"
                @input="getSelectedProvincia"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Distrito"
            rules="required"
          >
            <b-form-group
              label="Distrito"
              label-for="distrito"
              :state="getValidationState(validationContext)"
            >
              <v-select
                v-model="formData.distrito"
                placeholder=".: Seleccione Distrito :."
                :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                :options="optionDistrito"
                :reduce="m => m.codigoDistrito"
                label="descripcion"
                :clearable="false"
                input-id="descripcion"
                @input="getSelectedDistrito"
              />
              <b-form-invalid-feedback :state="getValidationState(validationContext)">
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>
          <validation-provider
            #default="validationContext"
            name="Dirección"
            rules="required"
          >
            <b-form-group
              label="Dirección"
              label-for="direccion"
            >
              <b-form-input
                id="direccion"
                v-model="formData.direccion"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Teléfono"
            rules="required"
          >
            <b-form-group
              label="Teléfono"
              label-for="telefono"
            >
              <b-form-input
                id="telefono"
                v-model="formData.telefono"
                :state="getValidationState(validationContext)"
                trim
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <validation-provider
            #default="validationContext"
            name="Email"
            rules="required|email"
          >
            <b-form-group
              label="Email"
              label-for="email"
            >
              <b-form-input
                id="email"
                v-model="formData.email"
                autofocus
                :state="getValidationState(validationContext)"
                trim
                placeholder=""
              />

              <b-form-invalid-feedback>
                {{ validationContext.errors[0] }}
              </b-form-invalid-feedback>
            </b-form-group>
          </validation-provider>

          <!-- Form Actions -->
          <div class="d-flex mt-2">
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="mr-2"
              type="submit"
              :disabled="isBusy"
            >
              Guardar
            </b-button>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              type="button"
              variant="outline-secondary"
              @click="hide"
            >
              Cancelar
            </b-button>
          </div>

        </b-form>
      </validation-observer>
    </template>
  </b-sidebar>
</template>

<script>
import {
  BSidebar, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BButton,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { ref } from '@vue/composition-api'
import { required } from '@validations'
import formValidation from '@core/comp-functions/forms/form-validation'
import Ripple from 'vue-ripple-directive'
import vSelect from 'vue-select'
import store from '@/store'
import { useNotify } from '@/helpers/toast'

export default {
  components: {
    BSidebar,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
    // Form Validation
    ValidationProvider,
    ValidationObserver,
  },
  directives: {
    Ripple,
  },
  model: {
    prop: 'isAddNewUserSidebarActive',
    event: 'update:is-add-new-user-sidebar-active',
  },
  props: {
    isAddNewUserSidebarActive: {
      type: Boolean,
      required: true,
    },
    dataEdit: {
      type: Object,
      required: false,
      default: null,
    },
    formType: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      required,
    }
  },
  setup(props, context) {
    const { notify } = useNotify(context)
    const titleForm = ref('')
    const optionDepartamento = ref([])
    const optionDistrito = ref([])
    const optionProvincia = ref([])
    const isBusy = ref(false)
    const blankData = {
      codigo: '',
      nombre: '',
      departamento: '',
      provincia: '',
      distrito: '',
      direccion: '',
      telefono: '',
      email: '',
      ubigeo: '',
    }
    const formData = ref(JSON.parse(JSON.stringify(blankData)))/* desestructuracion de  blankData */
    const resetData = () => {
      formData.value = JSON.parse(JSON.stringify(blankData))
    }
    const onSubmit = () => {
      isBusy.value = true
      let service = 'gsencuesta/INSTITUCION_CREATE'
      if (props.formType === 'edit') {
        service = 'gsencuesta/INSTITUCION_UPDATE'
      }
      store.dispatch(service, formData.value)
        .then(response => {
          isBusy.value = false
          context.emit('refetch-data', response)
          context.emit('update:is-add-new-user-sidebar-active', false)
        })
        .catch(error => {
          isBusy.value = false
          context.emit('error-data', error)
          context.emit('update:is-add-new-user-sidebar-active', false)
        })
    }
    const dataForm = () => {
      const provinciaDefault = {
        id: '',
        descripcion: '',
      }
      optionProvincia.value.unshift(provinciaDefault)
      const distritoDefault = {
        id: '',
        descripcion: '',
      }
      optionDistrito.value.unshift(distritoDefault)
      const deparmentDefault = {
        id: '',
        descripcion: '',
      }
      optionDepartamento.value.push(deparmentDefault)
      store
        .dispatch('gsencuesta/UBIGEO_FIND_ALL_DEPARTAMENTO', {})
        .then(response => {
          if (response !== undefined) {
            optionDepartamento.value = response
            optionDepartamento.value.unshift(deparmentDefault)
          }
        })
        .catch(error => {
          notify('Advertencia', error, 'danger')
        })
    }
    const loadProvincia = codigoDepartamento => {
      const provinciaDefault = {
        id: '',
        descripcion: '',
      }
      store
        .dispatch('gsencuesta/UBIGE_FIND_ALL_PROVINCIA', {
          id: codigoDepartamento,
        })
        .then(response => {
          if (response !== undefined) {
            optionProvincia.value = response
            optionProvincia.value.unshift(provinciaDefault)
          }
        })
        .catch(error => {
          notify('Advertencia', error, 'danger')
        })
    }
    const loadDistrito = codigoProvincia => {
      const distritoDefault = {
        id: '',
        descripcion: '',
      }
      store
        .dispatch('gsencuesta/UBIGE_FIND_ALL_DISTRITO', {
          codigoDepartamento: formData.value.departamento,
          codigoProvincia,
        })
        .then(response => {
          if (response !== undefined) {
            optionDistrito.value = response
            optionDistrito.value.unshift(distritoDefault)
          }
        })
        .catch(error => {
          notify('Advertencia', error, 'danger')
        })
    }
    const getSelectedDepartamento = option => {
      loadProvincia(option)
    }
    const getSelectedProvincia = option => {
      loadDistrito(option)
    }
    const getSelectedDistrito = option => {
      formData.value.ubigeo = formData.value.departamento + formData.value.provincia + option
    }
    const toggleSidebar = async val => {
      dataForm()
      context.emit('update:is-add-new-user-sidebar-active', val)
      if (props.formType === 'new') {
        titleForm.value = 'Agregar Institución'
      }
      if (props.formType === 'edit') {
        const ubigArray = []
        let valor = ''
        let statusUbigeo = true
        const ubig = props.dataEdit.ubigeo.split('')
        if (props.dataEdit.ubigeo !== null && props.dataEdit.ubigeo.length > 0) {
          ubig.forEach((dat, index) => {
            valor += dat
            if ((index + 1) % 2 === 0) {
              ubigArray.push(valor)
              valor = ''
            }
          })
        } else {
          statusUbigeo = false
        }
        formData.value = {
          idInstitucion: props.dataEdit.idInstitucion,
          codigo: props.dataEdit.codigo,
          nombre: props.dataEdit.nombre,
          direccion: props.dataEdit.direccion,
          telefono: props.dataEdit.telefono,
          email: props.dataEdit.email,
          departamento: (statusUbigeo) ? ubigArray[0] : '',
          provincia: (statusUbigeo) ? ubigArray[1] : '',
          distrito: (statusUbigeo) ? ubigArray[2] : '',
          ubigeo: (statusUbigeo) ? ubigArray[0] + ubigArray[1] + ubigArray[2] : '',
        }
        if (statusUbigeo) {
          await loadProvincia(ubigArray[0])
          await loadDistrito(ubigArray[1])
        }
        titleForm.value = 'Editar Institución'
      }
    }
    const {
      refFormObserver,
      getValidationState,
      resetForm,
    } = formValidation(resetData)
    return {
      formData,
      onSubmit,
      refFormObserver,
      getValidationState,
      resetForm,
      toggleSidebar,
      optionProvincia,
      optionDepartamento,
      optionDistrito,
      titleForm,
      getSelectedDepartamento,
      getSelectedProvincia,
      getSelectedDistrito,
      isBusy,
    }
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';

#add-new-user-sidebar {
  .vs__dropdown-menu {
    max-height: 200px !important;
  }
}
</style>
